export interface TimePerLoad {
  timePerLoadCode: string;
  timePerLoadDesc: string;
  timePerLoadId: number;
}
